import React from "react";
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Typography,
  Chip,
  Tooltip,
  IconButton,
} from "@mui/material";
import { useQuery } from "@apollo/client";
import { GET_POLICY_CHECKS_STATUS } from "../../../../apis/settingsApis/policy-apis/policyApis";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { CheckStatusChip } from "../../../../components/CheckStatusChip/CheckStatusChip";

const ChecksStatusCard = ({ policy, refetchTrigger }) => {
  const { data, loading, refetch } = useQuery(GET_POLICY_CHECKS_STATUS, {
    variables: { fileId: policy?.fileId },
    skip: !policy?.fileId,
  });

  // Add useEffect to refetch when policy changes
  React.useEffect(() => {
    if (policy?.fileId) {
      refetch();
    }
  }, [policy?.fileId, refetchTrigger, refetch]);

  const checks = data?.getFilePolicyCheckStatus || [];

  if (loading || checks.length === 0) {
    return null;
  }

  return (
    <Card
      variant="outlined"
      sx={{
        mb: 2,
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <CardHeader
        title="Policy Checks Status"
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 1,
          flexShrink: 0,
          borderBottom: "1px solid #ddd",
          background: "#F7F7FC",
          ".MuiCardHeader-title": { fontSize: "18px" },
          padding: "16px 18px",
        }}
      />
      <CardContent
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          overflowX: "hidden",
          padding: "20px 18px 24px",
          "&:last-child": { pb: 3 },
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {checks.map((check, index) => (
            <Box
              key={check.activeCheckId}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom:
                  index !== checks.length - 1 ? "1px solid #E0E0E0" : "none",
                paddingBottom: index !== checks.length - 1 ? 1.5 : 0,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body1">{check.activeCheckName}</Typography>
              </Box>
              <Tooltip title={check?.statusReason} arrow>
                <span>
                  <CheckStatusChip status={check?.status} />
                </span>
              </Tooltip>
            </Box>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default ChecksStatusCard;
